// extracted by mini-css-extract-plugin
module.exports = {"pageInner":"page-inner_pageInner__DAPy8"};